module.exports = __webpack_public_path__ + "img/u114.b765b263.svg";